import cx from 'classnames'

import Styles from './Spin.module.scss'
import { Spinner } from 'common/Spinner/Spinner'

interface Props {
  className?: string
}

export const Spin = ({ className }: Props) => <Spinner className={cx(className, Styles.spin)} />
